export const parseUrlParams = (str) => {
  const trimmedStr = str[0] === '?' ? str.slice(1) : '';

  const params = {};
  if (trimmedStr !== '') {
    trimmedStr.split('&').forEach((item) => {
      const arr = item.split('=');
      params[arr[0]] = arr[1];
    });
  }

  return params;
};

export const addLusaHeaderParam = (url) => {
  if (url && url.indexOf('?') > -1) {
    return `${url}&lusa_header=false`;
  } if (url) {
    return `${url}?lusa_header=false`;
  }
  return url;
};
